<template>
  <layout>
    <page-header :actions="actions" :header="$t('companies.company_prices')" />
    <div class="content transfer-pricing-cover">
      <AdminTable ref="table" v-bind="tableProps">
        <template #company_name="{ item }">
          <router-link
            :to="{ name: 'companies.edit', params: { id: item.company_id } }"
          >
            {{ item.company_name }}
          </router-link>
        </template>
        <template #minimum_price="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing.minimum_price }}</div>
        </template>
        <template #standard_price="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing.one_way || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing.return || '-' }}</div>
        </template>
        <template #price_from_5="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[0].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[0].price || '-' }}</div>
        </template>
        <template #price_from_10="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[1].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[1].price || '-' }}</div>
        </template>
        <template #price_from_15="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[2].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[2].price || '-' }}</div>
        </template>
        <template #price_from_20="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[3].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[3].price }}</div>
        </template>
        <template #price_from_30="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[4].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[4].price || '-' }}</div>
        </template>
        <template #price_from_50="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[5].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[5].price || '-' }}</div>
        </template>
        <template #price_from_100="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[6].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[6].price || '-' }}</div>
        </template>
        <template #price_from_150="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[7].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[7].price || '-' }}</div>
        </template>
        <template #price_from_200="{ item }">
          <div><i class="icon-arrow-right8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.price_per_km[8].price || '-' }}</div>
          <div><i class="icon-arrow-left8 text-muted text-sm mr-1"></i>{{ item.pricing && item.pricing.price_per_km && item.pricing.return_price_per_km[8].price || '-' }}</div>
        </template>
        <template #airport_name="{ item }">
          <router-link
            :to="{ name: 'airports.edit', params: { id: item.airport_id } }"
          >
            {{ item.airport_name }}
          </router-link>
        </template>
        <template #vehicle_name="{ item }">
          <router-link
            :to="{ name: 'vehicles.edit', params: { id: item.vehicle_id } }"
          >
            {{ item.vehicle_name }}
          </router-link>
        </template>
        <template #active="{ item }">
          <span v-if="item.active"><i style="font-size: 20px;color:green" class="icon-check text-sm mr-1"></i></span>
          <span v-if="!item.active"><i style="font-size: 20px;color: red" class="icon-x ql-color-green text-sm mr-1"></i></span>
        </template>
      </AdminTable>
    </div>
  </layout>
</template>

<script>
import {mapState} from 'vuex'
import AdminTable from '../components/AdminTable.vue'
import Api from './TransferPricingApi'

export default {
  name: 'TransferPricingIndex',

  components: {
    AdminTable
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
          apiBuilder() {
            return new Api()
          },
          beforeApiRequest(api) {
            api.setParameter('where[division_id]', this.currentDivision?.id)
          },
          afterApiRequest(api) {
            const loader = this.$loading.show(null, this.table)
            if (api.parameters.where?.airport_id == null && api.parameters.where?.vehicle_id == null){
              loader.hide()
            }
              setTimeout(() => {
                let pricesColumns = document.querySelectorAll('.pricing-columns');
                let priceColumnsArray = [...pricesColumns];
                let initialColumns = document.querySelectorAll('.initial-columns');
                let initialColumnsArray = [...initialColumns];
                if ((api.parameters && api.parameters.where) &&
                  (api.parameters.where.airport_id !== null && api.parameters.where.vehicle_id !== null)) {
                  initialColumnsArray.forEach(column => {
                    column.classList.add('hidden')
                  });
                  priceColumnsArray.forEach(column => {
                    column.classList.remove('hidden')
                  });
                } else {
                  priceColumnsArray.forEach(column => {
                    column.classList.add('hidden')
                  });
                  initialColumnsArray.forEach(column => {
                    column.classList.remove('hidden')
                  });
                }
                loader.hide()
              }, "1500")
          },
          columns: [
            {
              key: 'company_name',
              label: this.$t('companies.name'),
            },
            {
              key: 'minimum_price',
              label: this.$t('vehicles.minimum_price'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'standard_price',
              label: this.$t('vehicles.standard_price'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_5',
              label: this.$t('vehicles.price_from_5'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_10',
              label: this.$t('vehicles.price_from_10'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_15',
              label: this.$t('vehicles.price_from_15'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_20',
              label: this.$t('vehicles.price_from_20'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_30',
              label: this.$t('vehicles.price_from_30'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_50',
              label: this.$t('vehicles.price_from_50'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_100',
              label: this.$t('vehicles.price_from_100'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_150',
              label: this.$t('vehicles.price_from_150'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'price_from_200',
              label: this.$t('vehicles.price_from_200'),
              sortable: false,
              thClass: 'pricing-columns hidden',
              tdClass: 'pricing-columns hidden',
            },
            {
              key: 'airport_name',
              label: this.$t('airports.name'),
              thClass: 'initial-columns',
              tdClass: 'initial-columns',
            },
            {
              key: 'vehicle_name',
              label: this.$t('vehicles.name'),
              thClass: 'initial-columns',
              tdClass: 'initial-columns',
            },
            {
              key: 'created_at',
              label: this.$t('attributes.created_at'),
              component: 'value-date',
              config: {
                stacked: true,
              }
            },
            {
              key: 'active',
              label: this.$t('general.status'),
            },
          ],

          // override search fields here using fields schema
          searchFields: [
            {
              component: 'text-field',
              type: 'search',
              attribute: 'where.query',
              placeholder: 'Search ...',
            },
            {
              component: 'relation-field',
              attribute: 'where.airport_id',
              placeholder: this.$t('airports.name'),
              ajax: true,
              preload: true,
              select: true,
              source: {
                url: 'airports',
                params: {
                  division_id: this.currentDivision?.id,
                  context: 'options',
                }
              }
            },
            {
              component: 'relation-field',
              attribute: 'where.vehicle_id',
              placeholder: this.$t('vehicles.name'),
              ajax: true,
              preload: true,
              select: true,
              source: {
                url: 'vehicles',
                params: {
                  division_id: this.currentDivision?.id,
                  context: 'options',
                }
              }
            },
            {
              component: 'select-field',
              attribute: 'where.active',
              placeholder: this.$t('general.status'),
              options: [
                {
                  label: this.$t('general.active'),
                  value: 1,
                },
                {
                  label: this.$t('general.inactive'),
                  value: 0,
                },
              ]
            }
          ],
          // define custom row actions
          rowActions: (item) => {
            const rowActions = [
                {
                  label: this.$t('general.view'),
                  variant: 'light',
                  handler: () => {
                    this.$router.push({
                      name: 'company-pricings.transfer',
                      params: {
                        company_id: item.company_id,
                        airport_id: item.airport_id,
                        vehicle_id: item.vehicle_id,
                      }
                    })
                  }
                }
              ]
            if (this.$allows(`administer`)) {
              rowActions.push({
                label: this.$t('general.delete'),
                variant: 'danger',
                handler: () => {
                  this.deleteRow(item)
                }
              })
            }
            return rowActions
          },

          // define custom bulk actions
          bulkActions() {
            return []
          },
      },
    }
  },

  computed: {
    ...mapState('zones', ['currentDivision']),

    actions() {
      const actions = []
      if (this.$allows('administer')) {
        actions.push({
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.$router.push({
              name: 'company-pricings.transfer',
            })
          }
        })
      }
      return actions
    }
  },

  watch: {
    currentDivision() {
      this.$refs.table.refresh()
    }
  },

  methods: {
      async deleteRow(item) {
        const answer = !!(await this.$alert.question(
          this.$t('companies.messages.confirm_deleting'),
        )).value
        if (answer === false) {
          return
        }
        const promise = new Api()
          .destroy({
            company_id: item.company_id,
            airport_id: item.airport_id,
            vehicle_id: item.vehicle_id,
          })
          .then((result) => {
            this.$toast.success(result.message)
          })
        this.$refs.table.refresh()
        this.$uiBlocker(promise, this.$el)
      }
  },
}
</script>
<style>
.d-inline-block.mb-2.mr-sm-2 input {
  height: 40px;
}
.d-inline-block.mb-2.mr-sm-2 > div {
  max-height: 40px
}
</style>
